// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryFilterItem_category__2sVtF","collapse":"CategoryFilterItem_collapse__1jgCD"};